import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#FFE2BE"
      d="M27 7H5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"
    />
    <path
      fill="#E56B03"
      d="M12 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M17 14a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0zM20 11a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1"
    />
    <path
      fill="#E56B03"
      fillRule="evenodd"
      d="M17 4a1 1 0 1 0-2 0v2H5a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h4.92l-2.7 3.375a1 1 0 0 0 1.56 1.25L12.48 25h7.04l3.7 4.625a1 1 0 1 0 1.56-1.25L22.08 25H27a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H17zM5 8v15h22V8z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFilePresentation = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFilePresentation);
export default Memo;
